import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { Mbp3Service } from 'src/app/services/mbp3.service';
import { AlertComponent } from 'src/app/structure/alert/alert.component';
import { environment } from 'src/environments/environment';
declare var $: any;
import * as _ from 'lodash';
@Component({
  selector: 'app-mbp3list',
  templateUrl: './mbp3list.component.html',
  styleUrls: ['./mbp3list.component.css']
})
export class Mbp3listComponent implements OnInit {

  public environmentSettings: any;

  @ViewChildren(DataTableDirective)
  dtElements: QueryList<DataTableDirective>;
  dtOptionsOfMbp: DataTables.Settings = {};
  registerDirectorList: any[];
  masterDirectorList: any[];
  FromDateModelInMasterDirector: any;
  ToDateModelInMasterDirector: any;
  dtTriggerMbp: Subject<any> = new Subject();
  error: any = { isError: false, errorMessage: '' };
  futureToDate: NgbDateStruct;
  futureFromDate: NgbDateStruct;
  response: boolean;
  deleteMbpId: any;
  nameOfPerson: any;
  investmentHeldBy='';
  dateOfBoardResolution:any;
  particularId: any;
  dateOfDisposal: any;
  dateOfInvestment; any;
  isSearchDivVisible = false;
  constructor(private mbp3Service: Mbp3Service, private router: Router,
    private alert: AlertComponent,private activatedRoute: ActivatedRoute) {
    this.response = false;
  }
  ngOnInit() {
    this.environmentSettings = environment;
    this.dtOptionsOfMbp = {
      destroy: true,
      scrollX: true,
      scrollY: "210px",
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      stateSave: true,
      stateDuration: -1,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [8] }],
      dom: 'lBfrtip',//'Bfrtip',
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'MBP-3',
          title: 'MBP-3 - Investment not held by the Company in its own name',
          extend: 'excel',
          exportOptions: {
            columns: [0, 1, 3, 5, 7],
            format: {
              body: function ( data, row, column, node ) {
                  if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                    if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                  }else{ return data }
                }
            }
          }
        }
      ]
    };
    this.getMbpList();
  }
  add(){
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['mbp3','add']  } }],
      { relativeTo: this.activatedRoute.parent });
  }
  toggleSearchDiv() {
    this.isSearchDivVisible = !this.isSearchDivVisible;
  }
  getMbpList() {
    this.registerDirectorList = [];
    this.mbp3Service.getMbpList({ isSearch: false }).subscribe(registerList => {
      $("#directormasterMbp3Table").DataTable().destroy();
      this.registerDirectorList = registerList.data;
      this.dtTriggerMbp.next();
      // setTimeout(() => {
      //   this.dtTriggerMbp.next();
      // }, 200);
    });
  }

  confirmDelete(id) {
    this.deleteMbpId = id;
    $("#deleteConfirm").modal('toggle');
  }

  deleteMbpDetail() {
    this.mbp3Service.deleteMbpData(this.deleteMbpId)
      .subscribe(response => {
        if (response.status == 0) {
          this.alert.success(response.message);
          $("#directormasterMbp3Table").DataTable().destroy();
          $("#deleteConfirm").modal('toggle');
          this.getMbpList();
        } else {
          this.alert.error(response.message);
        }
      });
  }

  editMbpDetails(_id) {
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['mbp3','edit',_id]  } }],
      { relativeTo: this.activatedRoute.parent });
    // this.router.navigate(['mbp3/edit/', _id]);
  }
  generateOutput() {
    let companyId = JSON.parse(localStorage.getItem('companyDetails')).companyID;
    var object = {
      id: null,
      fromDate: this.dateOfDisposal,
      toDate: this.dateOfInvestment,
      name: this.nameOfPerson,
      param1: this.investmentHeldBy,
      date1: this.dateOfBoardResolution
    }
    this.mbp3Service.generateMbp3Document(object).subscribe(response => {
      if (response.status == 0) {
        this.alert.success(response.message);
        var self = this;
        setTimeout(function () {
          self.downloadDocument(companyId);
          setTimeout(function () {
            self.downloadPdfDocument(companyId);
          }, 1000);
        }, 1000);
      } else {
        this.alert.error(response.message);
      }
    })
  }

  downloadDocument(id) {
    this.mbp3Service.downloadMbp3File(id, 'Multi');
  }
  downloadPdfDocument(id) {
    this.mbp3Service.downloadMbp3PdfFile(id, 'Multi');
  }

  setDate(date) {
    if (date != "" && date != null) {
      return date.month + "-" + date.day + "-" + date.year;
    }
    return null;
  }

  doAdvSearch() {
    this.response = true;
    var searchParam =
    {
      "nameOfThePersonInvestment": this.nameOfPerson,
      "investmentHeldBy":this.investmentHeldBy,
      "dateOfBoardResolution":this.setDate(this.dateOfBoardResolution),
      "dateOfDisposal":this.setDate(this.dateOfDisposal),
      "dateOfInvestment":this.setDate(this.dateOfInvestment),
      'isSearch': true,
    };
    this.registerDirectorList = [];
    $("#directormasterMbp3Table").DataTable().destroy();
    this.mbp3Service.getMbpList(searchParam).subscribe(registerList => {
      this.response = false;
      this.registerDirectorList = registerList.data;
      this.dtTriggerMbp.next();
    });
  }
  clearAdvSearch() {
    this.nameOfPerson = '';
    this.investmentHeldBy=''
    this.dateOfBoardResolution='';
    this.dateOfDisposal='';
    this.dateOfInvestment='';
    $("#directormasterMbp3Table").DataTable().destroy();
    this.getMbpList();
    this.response = false;
  }
}
